import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Heart, Users, GraduationCap } from 'lucide-react';
import { SectionHeading, Badge } from '../components/ui';
export const FundraiserPage = () => {
  return <div className="w-full pt-20" data-id="element-533">
      {/* HERO */}
      <section className="py-24 bg-charcoal text-center border-b border-white/5" data-id="element-534">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-535">
          <Badge color="lime" className="mb-6" data-id="element-536">
            GIVING BACK
          </Badge>
          <h1 className="text-6xl md:text-8xl font-black font-heading uppercase -skew-x-6 mb-8 text-white" data-id="element-537">
            ROAST SOMEBODY. <br data-id="element-538" />
            <span className="text-lime" data-id="element-539">HELP A KID.</span>
          </h1>
          <p className="text-xl md:text-2xl text-slate font-medium max-w-3xl mx-auto" data-id="element-540">
            20% of every subscription goes to school fundraising programs. The
            funnier your league gets, the more schools benefit.
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-24 bg-dark border-b border-white/5" data-id="element-541">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-542">
          <SectionHeading title="HOW SCHOOL SPIRIT MODE WORKS" className="text-center mb-16" data-id="element-543" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-544">
            <motion.div whileHover={{
            y: -5
          }} className="bg-charcoal p-8 rounded-2xl border border-blue-500/30 text-center" data-id="element-545">
              <div className="w-16 h-16 bg-blue-500/20 text-blue-400 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-546">
                <GraduationCap size={32} data-id="element-547" />
              </div>
              <h4 className="font-heading font-black text-2xl uppercase tracking-wide mb-4 text-white" data-id="element-548">
                SET UP YOUR LEAGUE
              </h4>
              <p className="text-slate" data-id="element-549">
                Schools, teams, and organizations get a dedicated page at
                ITSONfantasy.com/support/[yourname]. School Spirit Mode locks
                commentary to family-safe Tier 1.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-charcoal p-8 rounded-2xl border border-blue-500/30 text-center" data-id="element-550">
              <div className="w-16 h-16 bg-blue-500/20 text-blue-400 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-551">
                <Users size={32} data-id="element-552" />
              </div>
              <h4 className="font-heading font-black text-2xl uppercase tracking-wide mb-4 text-white" data-id="element-553">
                SPREAD THE WORD
              </h4>
              <p className="text-slate" data-id="element-554">
                Parent referral mechanic — refer a family, get next season free.
                Every signup through your link raises money for your program.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-charcoal p-8 rounded-2xl border border-blue-500/30 text-center" data-id="element-555">
              <div className="w-16 h-16 bg-blue-500/20 text-blue-400 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-556">
                <Heart size={32} data-id="element-557" />
              </div>
              <h4 className="font-heading font-black text-2xl uppercase tracking-wide mb-4 text-white" data-id="element-558">
                WATCH IT GROW
              </h4>
              <p className="text-slate" data-id="element-559">
                Custom org affiliate rates available. The more your community
                plays, the more your program earns. Fantasy football that
                actually does something good.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="py-24 bg-charcoal" data-id="element-560">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-561">
          <SectionHeading title="WHAT YOU GET" className="text-center mb-12" data-id="element-562" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-563">
            {['Dedicated fundraiser page at ITSONfantasy.com/support/[schoolname]', 'Parent referral mechanic — refer a family, get next season free', 'Custom org affiliate rates available', '100% family-safe commentary — school board approved', '20% of every subscription goes directly to your program', 'Commissioner dashboard to track signups and earnings'].map((feature, i) => <div key={i} className="flex items-start gap-4 bg-dark p-6 rounded-2xl border border-white/10" data-id="element-564">
                <div className="bg-blue-500/20 p-2 rounded-full text-blue-400 shrink-0" data-id="element-565">
                  <Zap size={20} className="fill-current" data-id="element-566" />
                </div>
                <p className="text-slate-200 font-medium" data-id="element-567">{feature}</p>
              </div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-568">
            <button className="bg-blue-500 text-white px-10 py-5 rounded-xl font-black font-heading text-2xl uppercase tracking-wide hover:bg-blue-600 transition-all" data-id="element-569">
              Set Up Your School League
            </button>
            <p className="text-slate text-sm mt-4" data-id="element-570">
              Questions? Email us at schools@itsonfantasy.com
            </p>
          </div>
        </div>
      </section>

      {/* FUNDRAISING BANNER */}
      <section className="py-20 bg-lime text-charcoal relative overflow-hidden" data-id="element-571">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]" data-id="element-572"></div>
        <div className="container mx-auto px-4 relative z-10 text-center max-w-4xl" data-id="element-573">
          <h2 className="text-5xl md:text-7xl font-black font-heading uppercase -skew-x-6 mb-6 tracking-tighter" data-id="element-574">
            GIVING BACK WITH EVERY ROAST
          </h2>
          <p className="text-2xl font-bold" data-id="element-575">
            Every league. Every tier. Every season. 20% goes back to schools. No
            exceptions.
          </p>
        </div>
      </section>
    </div>;
};